<div id="invoice-preview-container-wrapper" class="k-h-full">
  <app-invoice-theme-shell [mode]="mode()" />
</div>
